import React, { useEffect, useState } from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import Logo from "../../assets/logo/logo.png";
import { useLocation } from "react-router-dom";
import { fetchProductCategories } from '../../store/Category/categoriesSlice';
import { useDispatch, useSelector } from 'react-redux';

const Sidebar = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [activeItem, setActiveItem] = useState('');
    const [activeSubItem, setActiveSubItem] = useState('');
    const getActiveItems = () => {
        const path = location.pathname;
        const params = new URLSearchParams(location.search);
        const rawCategory = params.get('category');
        const decodedCategory = rawCategory ? decodeURIComponent(rawCategory) : '';
        console.log(decodedCategory)
        if (path.startsWith('/members/timeTracker')) return { main: 'members', sub: 'timeTracker' };
        if (path.startsWith('/dashboard')) return { main: 'dashboard', sub: '' };
        if (path.startsWith('/members')) return { main: 'members', sub: '' };
        if (path.startsWith('/subscriptions')) return { main: 'subscriptions', sub: path.includes('/create') ? 'create' : '' };
        if (path.startsWith('/blogs')) return { main: 'blogs', sub: path.includes('/create') ? 'create' : '', sub: path.includes('/tags') ? 'tags' : '', sub: path.includes('/categories') ? 'categories' : '' };
        if (path.startsWith('/transactions')) return { main: 'transactions', sub: '' };
        if (path.startsWith('/categories')) return { main: 'categories', sub: '' };
        if (path.startsWith('/notifications')) return { main: 'notifications', sub: '' };
        if (path.startsWith('/modules')) return { main: 'modules', sub: '' };
        if (path.startsWith('/product')) {
            return { main: 'product', sub: decodedCategory };
        }

        return { main: '', sub: '' };
    };



    useEffect(() => {
        const { main, sub } = getActiveItems();
        setActiveItem(main);
        setActiveSubItem(sub);
    }, [location.pathname, dispatch]);


    useEffect(() => {
        dispatch(fetchProductCategories());
    }, [dispatch]);

    const isSubItemActive = (subItemPath) => {
        const params = new URLSearchParams(location.search);
        const rawCategory = params.get('category');
        const decodedCategory = rawCategory ? decodeURIComponent(rawCategory) : '';
        if (location.pathname.startsWith('/product')) {
            return decodedCategory === subItemPath;
        }

        return activeSubItem === subItemPath || location.pathname.includes(subItemPath);
    };

    return (
        <nav className="navbar navbar-vertical navbar-expand-lg sidebar">
            <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
                <div className="navbar-vertical-content">
                    <ul className="navbar-nav flex-column" id="navbarVerticalNav">
                        <li className="nav-item text-center">
                            <img src={Logo} alt="Logo" className="img-fluid mt-0 my-5 w-75" />
                        </li>
                        <li className="nav-item">
                            <div className="nav-item-wrapper">
                                <RouterNavLink className={`nav-link dropdown-indicator label-1 collapsed ${activeItem === 'dashboard' ? 'activeBtn' : ''} `} to="/dashboard" >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                        </div>
                                        <span className="nav-link-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user me-2 text-body align-bottom">
                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                <circle cx="12" cy="7" r="4"></circle>
                                            </svg>

                                        </span>
                                        <span className="nav-link-text">Dashboard</span>
                                    </div>
                                </RouterNavLink>
                            </div>
                        </li>
                        <li className="nav-item">
                            <div className="nav-item-wrapper">
                                <RouterNavLink className={`nav-link dropdown-indicator label-1 collapsed ${activeItem === 'members' ? 'activeBtn' : ''} `} to="/members" >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                        </div>
                                        <span className="nav-link-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user me-2 text-body align-bottom">
                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                <circle cx="12" cy="7" r="4"></circle>
                                            </svg>

                                        </span>
                                        <span className="nav-link-text">Members</span>
                                    </div>
                                </RouterNavLink>
                            </div>
                        </li>
                        <li className={`subMenuList ${activeItem === 'members' ? '' : 'd-none'} ${isSubItemActive('timeTracker') ? 'active' : ''}`}>
                            <RouterNavLink className="linkToUrl" to="/members/timeTracker">
                                <div className="d-flex justify-content-start pl-44">
                                    <span className="linkTest">- Time Tracker</span>
                                </div>
                            </RouterNavLink>
                        </li>
                        <li className="nav-item">
                            <div className="nav-item-wrapper">
                                <RouterNavLink className={`nav-link dropdown-indicator label-1 collapsed ${activeItem === 'blogs' ? 'activeBtn' : ''} `} to="/blogs" >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                        </div>
                                        <span className="nav-link-icon">
                                            <svg
                                                width="22"
                                                height="22"
                                                viewBox="0 0 64 64"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect x="12" y="8" width="40" height="48" stroke="black" stroke-width="2" fill="none" rx="2" ry="2" />
                                                <path d="M52 8v12h-12" stroke="black" stroke-width="2" fill="none" />
                                                <line x1="20" y1="24" x2="44" y2="24" stroke="black" stroke-width="2" />
                                                <line x1="20" y1="32" x2="44" y2="32" stroke="black" stroke-width="2" />
                                                <line x1="20" y1="40" x2="44" y2="40" stroke="black" stroke-width="2" />
                                                <line x1="20" y1="48" x2="36" y2="48" stroke="black" stroke-width="2" />
                                            </svg>

                                        </span>
                                        <span className="nav-link-text">Blogs</span>
                                    </div>
                                </RouterNavLink>
                            </div>
                        </li>
                        <li className={`subMenuList ${activeItem === 'blogs' ? '' : 'd-none'} ${isSubItemActive('create') ? 'active' : ''} `}>
                            <RouterNavLink className="linkToUrl " to="/blogs/create">
                                <div className="d-flex justify-content-start pl-44" style={{ width: '198px' }}>
                                    <span className="linkTest">- Create</span>
                                </div>
                            </RouterNavLink>
                        </li>
                        <li className={`subMenuList ${activeItem === 'blogs' ? '' : 'd-none'} ${isSubItemActive('tags') ? 'active' : ''} `}>
                            <RouterNavLink className="linkToUrl " to="/blogs/tags">
                                <div className="d-flex justify-content-start pl-44" style={{ width: '198px' }}>
                                    <span className="linkTest">- Tags</span>
                                </div>
                            </RouterNavLink>
                        </li>
                        <li className={`subMenuList ${activeItem === 'blogs' ? '' : 'd-none'} ${isSubItemActive('categories') ? 'active' : ''} `}>
                            <RouterNavLink className="linkToUrl " to="/blogs/categories">
                                <div className="d-flex justify-content-start pl-44" style={{ width: '198px' }}>
                                    <span className="linkTest">- Categories</span>
                                </div>
                            </RouterNavLink>
                        </li>
                        <li className="nav-item">
                            <div className="nav-item-wrapper">
                                <RouterNavLink className={`nav-link dropdown-indicator label-1 ${activeItem === 'transactions' ? 'activeBtn' : ''} `} to="/transactions" >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                        </div>
                                        <span className="nav-link-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 576 512"><path d="M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm64 320l-64 0 0-64c35.3 0 64 28.7 64 64zM64 192l0-64 64 0c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" /></svg>
                                        </span>
                                        <span className="nav-link-text">Transactions</span>
                                    </div>
                                </RouterNavLink>
                            </div>
                        </li>
                        <li className="nav-item">
                            <div className="nav-item-wrapper">
                                <RouterNavLink className={`nav-link dropdown-indicator label-1 collapsed ${activeItem === 'modules' ? 'activeBtn' : ''} `} to="/modules" >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                        </div>
                                        <span className="nav-link-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="   " height="22px">
                                                <path d="M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z" />
                                            </svg>
                                        </span>
                                        <span className="nav-link-text">Manage Modules</span>
                                    </div>
                                </RouterNavLink>
                            </div>
                        </li>
                        <li className="nav-item">
                            <div className="nav-item-wrapper">
                                <RouterNavLink className={`nav-link dropdown-indicator label-1 collapsed ${activeItem === 'notifications' ? 'activeBtn' : ''} `} to="/notifications" >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                        </div>
                                        <span className="nav-link-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="22px" height="22px"><path d="M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" /></svg>
                                        </span>
                                        <span className="nav-link-text">Notifications</span>
                                    </div>
                                </RouterNavLink>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
            <div className="navbar-vertical-footer" style={{marginLeft : '-11px'}}>
                <div className="d-flex justify-content-center align-items-center w-100">
                    <span className="navbar-vertical-footer-text">
                        Shiftnpay &copy; {new Date().getFullYear()}
                    </span>
                </div>
            </div>
        </nav>
    );
};

export default Sidebar;